"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBrokingSlipDto = exports.CreateBrokingSlipVersionDto = exports.CreateBrokingSlipVersionDetailsDto = exports.CreateCoversDto = exports.CreatePreferredTpaDto = exports.CreatePreferredInsurerDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const get_broking_slip_details_by_version_dto_1 = require("./get-broking-slip-details-by-version.dto");
class CreatePreferredInsurerDto {
}
exports.CreatePreferredInsurerDto = CreatePreferredInsurerDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the preferred insurer.",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Preferred insurer ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Preferred insurer ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreatePreferredInsurerDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Location Id of the preferred TPA.",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Preferred location ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Preferred location ID is required." }),
    tslib_1.__metadata("design:type", String)
], CreatePreferredInsurerDto.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Branch Id of the preferred TPA.",
        example: 1681,
    }),
    (0, class_validator_1.IsInt)({ message: "Preferred branch ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Preferred branch ID is required." }),
    tslib_1.__metadata("design:type", String)
], CreatePreferredInsurerDto.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the contact person.",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Contact ID must be an integer." }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreatePreferredInsurerDto.prototype, "contactId", void 0);
class CreatePreferredTpaDto {
}
exports.CreatePreferredTpaDto = CreatePreferredTpaDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the preferred TPA.",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Preferred TPA ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Preferred TPA ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreatePreferredTpaDto.prototype, "tpaId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Location Id of the preferred TPA.",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Preferred location ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Preferred location ID is required." }),
    tslib_1.__metadata("design:type", String)
], CreatePreferredTpaDto.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Branch Id of the preferred TPA.",
        example: 1681,
    }),
    (0, class_validator_1.IsInt)({ message: "Preferred branch ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Preferred branch ID is required." }),
    tslib_1.__metadata("design:type", String)
], CreatePreferredTpaDto.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the contact person.",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Contact ID must be an integer." }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreatePreferredTpaDto.prototype, "contactId", void 0);
class CreateCoversDto {
}
exports.CreateCoversDto = CreateCoversDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the opportunity activity.",
        example: 76,
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateCoversDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the cover mapped to the opportunity.",
        example: 76,
    }),
    (0, class_validator_1.IsInt)({ message: "Cover map id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateCoversDto.prototype, "coverMapId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the policy mapped to the opportunity.",
        example: 76,
    }),
    (0, class_validator_1.IsInt)({ message: "policy map id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateCoversDto.prototype, "policyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Name of the cover.",
        example: "High class covers",
    }),
    (0, class_validator_1.IsString)({ message: "Cover Name must be a string." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Cover Name is required." }),
    tslib_1.__metadata("design:type", String)
], CreateCoversDto.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Response of the cover.",
        example: "Sample cover response",
    }),
    (0, class_validator_1.IsString)({ message: "Cover Response must be a string." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Cover Response is required." }),
    tslib_1.__metadata("design:type", String)
], CreateCoversDto.prototype, "coverResponse", void 0);
class CreateBrokingSlipVersionDetailsDto {
}
exports.CreateBrokingSlipVersionDetailsDto = CreateBrokingSlipVersionDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the opportunity activity.",
        example: 76,
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateBrokingSlipVersionDetailsDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The sum insured amount.",
        example: 1000000,
    }),
    (0, class_validator_1.IsInt)({ message: "Sum insured must be an integer." }),
    (0, class_validator_1.Min)(0, { message: "Sum insured must be a positive number." }),
    tslib_1.__metadata("design:type", Number)
], CreateBrokingSlipVersionDetailsDto.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "It is the name of the  version of broking slip getting created",
        example: "High class covers ",
    }),
    (0, class_validator_1.IsString)({ message: "version name must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateBrokingSlipVersionDetailsDto.prototype, "versionName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "The brokerage percentage.",
        example: 2.5,
    }),
    (0, class_validator_1.IsNumber)({}, { message: "Brokerage percentage must be a number." }),
    (0, class_validator_1.Min)(0, { message: "Brokerage percentage must be a positive number." }),
    (0, class_validator_1.Max)(100, {
        message: "Brokerage percentage must be less than or equal to 100.",
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreateBrokingSlipVersionDetailsDto.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The date when the policy starts.",
        example: "2025-12-10",
    }),
    (0, class_validator_1.IsDate)({ message: "Policy from must be a valid date." }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsNotEmpty)({ message: "Policy from is required." }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateBrokingSlipVersionDetailsDto.prototype, "policyFrom", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The date when the policy ends.",
        example: "2025-12-10",
    }),
    (0, class_validator_1.IsDate)({ message: "Policy to must be a valid date." }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsNotEmpty)({ message: "Policy to is required." }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateBrokingSlipVersionDetailsDto.prototype, "policyTo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The date when the renewal is due.",
        example: "2025-12-10",
    }),
    (0, class_validator_1.IsDate)({ message: "Renewal date must be a valid date." }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsNotEmpty)({ message: "Renewal date is required." }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], CreateBrokingSlipVersionDetailsDto.prototype, "renewalDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The date when the quote receipt timeline is set.",
        example: "2025-12-10",
    }),
    (0, class_validator_1.IsDate)({ message: "Quote receipt timeline must be a valid date." }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsNotEmpty)({ message: "Quote receipt timeline is required." }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], CreateBrokingSlipVersionDetailsDto.prototype, "quoteReceiptTimeline", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "The business activity related to the opportunity.",
        example: "Manufacturing",
    }),
    (0, class_validator_1.IsString)({ message: "Business activity must be a string." }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], CreateBrokingSlipVersionDetailsDto.prototype, "businessActivity", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The risk mitigation features related to the opportunity.",
        example: "The risk mitigation features include fire alarms, sprinklers, and security systems.",
    }),
    (0, class_validator_1.IsString)({ message: "Risk mitigation features must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateBrokingSlipVersionDetailsDto.prototype, "riskMitigationFeatures", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The clauses related to the opportunity.",
        example: "No claims made in the last 5 years.",
    }),
    (0, class_validator_1.IsString)({ message: "Clauses must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateBrokingSlipVersionDetailsDto.prototype, "clauses", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The insurer remarks related to the opportunity.",
        example: "The insurer has approved the risk assessment.",
    }),
    (0, class_validator_1.IsString)({ message: "Insurer remarks must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateBrokingSlipVersionDetailsDto.prototype, "insurerRemarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The remarks related to the opportunity.",
        example: "This is a high-value opportunity.",
    }),
    (0, class_validator_1.IsString)({ message: "remarks must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateBrokingSlipVersionDetailsDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Preferred insurer details",
        type: [CreatePreferredInsurerDto],
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreatePreferredInsurerDto),
    tslib_1.__metadata("design:type", Array)
], CreateBrokingSlipVersionDetailsDto.prototype, "preferredInsurerDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Preferred TPA details",
        type: [CreatePreferredTpaDto],
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreatePreferredTpaDto),
    tslib_1.__metadata("design:type", Array)
], CreateBrokingSlipVersionDetailsDto.prototype, "preferredTpaDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Cover details",
        type: [CreateCoversDto],
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateCoversDto),
    tslib_1.__metadata("design:type", Array)
], CreateBrokingSlipVersionDetailsDto.prototype, "coverDetails", void 0);
class CreateBrokingSlipVersionDto {
}
exports.CreateBrokingSlipVersionDto = CreateBrokingSlipVersionDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the opportunity activity.",
        example: 76,
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateBrokingSlipVersionDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "status id of the activity.",
        example: 76,
    }),
    (0, class_validator_1.IsInt)({ message: "Status id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateBrokingSlipVersionDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Broking slip version details",
        type: get_broking_slip_details_by_version_dto_1.BrokingSlipVersionDetailsDto,
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => get_broking_slip_details_by_version_dto_1.BrokingSlipVersionDetailsDto),
    tslib_1.__metadata("design:type", typeof (_e = typeof get_broking_slip_details_by_version_dto_1.BrokingSlipVersionDetailsDto !== "undefined" && get_broking_slip_details_by_version_dto_1.BrokingSlipVersionDetailsDto) === "function" ? _e : Object)
], CreateBrokingSlipVersionDto.prototype, "brokingSlipVersionDetails", void 0);
class CreateBrokingSlipDto {
}
exports.CreateBrokingSlipDto = CreateBrokingSlipDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "The ID of the opportunity activity.",
        example: 76,
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateBrokingSlipDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "status id of the activity.",
        example: 76,
    }),
    (0, class_validator_1.IsInt)({ message: "Status id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateBrokingSlipDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Broking slip version details",
        type: get_broking_slip_details_by_version_dto_1.BrokingSlipFormDataDto,
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => get_broking_slip_details_by_version_dto_1.BrokingSlipFormDataDto),
    tslib_1.__metadata("design:type", typeof (_f = typeof get_broking_slip_details_by_version_dto_1.BrokingSlipFormDataDto !== "undefined" && get_broking_slip_details_by_version_dto_1.BrokingSlipFormDataDto) === "function" ? _f : Object)
], CreateBrokingSlipDto.prototype, "brokingSlipDetails", void 0);
